"use strict";

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _assertThisInitialized = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertIsNextArbitrary = exports.NextArbitrary = void 0;

var Stream_1 = require("../../../stream/Stream");

var symbols_1 = require("../../symbols");

var NextValue_1 = require("./NextValue");

var NextArbitrary = /*#__PURE__*/function () {
  function NextArbitrary() {
    _classCallCheck(this, NextArbitrary);
  }

  _createClass(NextArbitrary, [{
    key: "filter",
    value: function filter(refinement) {
      return new FilterArbitrary(this, refinement);
    }
  }, {
    key: "map",
    value: function map(mapper, unmapper) {
      return new MapArbitrary(this, mapper, unmapper);
    }
  }, {
    key: "chain",
    value: function chain(chainer) {
      return new ChainArbitrary(this, chainer);
    }
  }, {
    key: "noShrink",
    value: function noShrink() {
      return new NoShrinkArbitrary(this);
    }
  }, {
    key: "noBias",
    value: function noBias() {
      return new NoBiasArbitrary(this);
    }
  }]);

  return NextArbitrary;
}();

exports.NextArbitrary = NextArbitrary;

var ChainArbitrary = /*#__PURE__*/function (_NextArbitrary) {
  _inherits(ChainArbitrary, _NextArbitrary);

  var _super = _createSuper(ChainArbitrary);

  function ChainArbitrary(arb, chainer) {
    var _this;

    _classCallCheck(this, ChainArbitrary);

    _this = _super.call(this);
    _this.arb = arb;
    _this.chainer = chainer;
    return _this;
  }

  _createClass(ChainArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var clonedMrng = mrng.clone();
      var src = this.arb.generate(mrng, biasFactor);
      return this.valueChainer(src, mrng, clonedMrng, biasFactor);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return false;
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      var _this2 = this;

      if (this.isSafeContext(context)) {
        return (!context.stoppedForOriginal ? this.arb.shrink(context.originalValue, context.originalContext).map(function (v) {
          return _this2.valueChainer(v, context.clonedMrng.clone(), context.clonedMrng, context.originalBias);
        }) : Stream_1.Stream.nil()).join(context.chainedArbitrary.shrink(value, context.chainedContext).map(function (dst) {
          var newContext = Object.assign(Object.assign({}, context), {
            chainedContext: dst.context,
            stoppedForOriginal: true
          });
          return new NextValue_1.NextValue(dst.value_, newContext);
        }));
      }

      return Stream_1.Stream.nil();
    }
  }, {
    key: "valueChainer",
    value: function valueChainer(v, generateMrng, clonedMrng, biasFactor) {
      var chainedArbitrary = this.chainer(v.value_);
      var dst = chainedArbitrary.generate(generateMrng, biasFactor);
      var context = {
        originalBias: biasFactor,
        originalValue: v.value_,
        originalContext: v.context,
        stoppedForOriginal: false,
        chainedArbitrary: chainedArbitrary,
        chainedContext: dst.context,
        clonedMrng: clonedMrng
      };
      return new NextValue_1.NextValue(dst.value_, context);
    }
  }, {
    key: "isSafeContext",
    value: function isSafeContext(context) {
      return context != null && typeof context === 'object' && 'originalBias' in context && 'originalValue' in context && 'originalContext' in context && 'stoppedForOriginal' in context && 'chainedArbitrary' in context && 'chainedContext' in context && 'clonedMrng' in context;
    }
  }]);

  return ChainArbitrary;
}(NextArbitrary);

var MapArbitrary = /*#__PURE__*/function (_NextArbitrary2) {
  _inherits(MapArbitrary, _NextArbitrary2);

  var _super2 = _createSuper(MapArbitrary);

  function MapArbitrary(arb, mapper, unmapper) {
    var _this3;

    _classCallCheck(this, MapArbitrary);

    _this3 = _super2.call(this);
    _this3.arb = arb;
    _this3.mapper = mapper;
    _this3.unmapper = unmapper;
    _this3.bindValueMapper = _this3.valueMapper.bind(_assertThisInitialized(_this3));
    return _this3;
  }

  _createClass(MapArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var g = this.arb.generate(mrng, biasFactor);
      return this.valueMapper(g);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      if (this.unmapper !== undefined) {
        try {
          var unmapped = this.unmapper(value);
          return this.arb.canShrinkWithoutContext(unmapped);
        } catch (_err) {
          return false;
        }
      }

      return false;
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      if (this.isSafeContext(context)) {
        return this.arb.shrink(context.originalValue, context.originalContext).map(this.bindValueMapper);
      }

      if (this.unmapper !== undefined) {
        var unmapped = this.unmapper(value);
        return this.arb.shrink(unmapped, undefined).map(this.bindValueMapper);
      }

      return Stream_1.Stream.nil();
    }
  }, {
    key: "mapperWithCloneIfNeeded",
    value: function mapperWithCloneIfNeeded(v) {
      var _this4 = this;

      var sourceValue = v.value;
      var mappedValue = this.mapper(sourceValue);

      if (v.hasToBeCloned && (typeof mappedValue === 'object' && mappedValue !== null || typeof mappedValue === 'function') && Object.isExtensible(mappedValue) && !(0, symbols_1.hasCloneMethod)(mappedValue)) {
        Object.defineProperty(mappedValue, symbols_1.cloneMethod, {
          get: function get() {
            return function () {
              return _this4.mapperWithCloneIfNeeded(v)[0];
            };
          }
        });
      }

      return [mappedValue, sourceValue];
    }
  }, {
    key: "valueMapper",
    value: function valueMapper(v) {
      var _this$mapperWithClone = this.mapperWithCloneIfNeeded(v),
          _this$mapperWithClone2 = _slicedToArray(_this$mapperWithClone, 2),
          mappedValue = _this$mapperWithClone2[0],
          sourceValue = _this$mapperWithClone2[1];

      var context = {
        originalValue: sourceValue,
        originalContext: v.context
      };
      return new NextValue_1.NextValue(mappedValue, context);
    }
  }, {
    key: "isSafeContext",
    value: function isSafeContext(context) {
      return context != null && typeof context === 'object' && 'originalValue' in context && 'originalContext' in context;
    }
  }]);

  return MapArbitrary;
}(NextArbitrary);

var FilterArbitrary = /*#__PURE__*/function (_NextArbitrary3) {
  _inherits(FilterArbitrary, _NextArbitrary3);

  var _super3 = _createSuper(FilterArbitrary);

  function FilterArbitrary(arb, refinement) {
    var _this5;

    _classCallCheck(this, FilterArbitrary);

    _this5 = _super3.call(this);
    _this5.arb = arb;
    _this5.refinement = refinement;
    _this5.bindRefinementOnValue = _this5.refinementOnValue.bind(_assertThisInitialized(_this5));
    return _this5;
  }

  _createClass(FilterArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      while (true) {
        var g = this.arb.generate(mrng, biasFactor);

        if (this.refinementOnValue(g)) {
          return g;
        }
      }
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return this.arb.canShrinkWithoutContext(value) && this.refinement(value);
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      return this.arb.shrink(value, context).filter(this.bindRefinementOnValue);
    }
  }, {
    key: "refinementOnValue",
    value: function refinementOnValue(v) {
      return this.refinement(v.value);
    }
  }]);

  return FilterArbitrary;
}(NextArbitrary);

var NoShrinkArbitrary = /*#__PURE__*/function (_NextArbitrary4) {
  _inherits(NoShrinkArbitrary, _NextArbitrary4);

  var _super4 = _createSuper(NoShrinkArbitrary);

  function NoShrinkArbitrary(arb) {
    var _this6;

    _classCallCheck(this, NoShrinkArbitrary);

    _this6 = _super4.call(this);
    _this6.arb = arb;
    return _this6;
  }

  _createClass(NoShrinkArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      return this.arb.generate(mrng, biasFactor);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return this.arb.canShrinkWithoutContext(value);
    }
  }, {
    key: "shrink",
    value: function shrink(_value, _context) {
      return Stream_1.Stream.nil();
    }
  }, {
    key: "noShrink",
    value: function noShrink() {
      return this;
    }
  }]);

  return NoShrinkArbitrary;
}(NextArbitrary);

var NoBiasArbitrary = /*#__PURE__*/function (_NextArbitrary5) {
  _inherits(NoBiasArbitrary, _NextArbitrary5);

  var _super5 = _createSuper(NoBiasArbitrary);

  function NoBiasArbitrary(arb) {
    var _this7;

    _classCallCheck(this, NoBiasArbitrary);

    _this7 = _super5.call(this);
    _this7.arb = arb;
    return _this7;
  }

  _createClass(NoBiasArbitrary, [{
    key: "generate",
    value: function generate(mrng, _biasFactor) {
      return this.arb.generate(mrng, undefined);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return this.arb.canShrinkWithoutContext(value);
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      return this.arb.shrink(value, context);
    }
  }, {
    key: "noBias",
    value: function noBias() {
      return this;
    }
  }]);

  return NoBiasArbitrary;
}(NextArbitrary);

function assertIsNextArbitrary(instance) {
  if (typeof instance !== 'object' || instance === null || !('generate' in instance) || !('shrink' in instance) || 'shrinkableFor' in instance) {
    throw new Error('Unexpected value received: not an instance of NextArbitrary');
  }
}

exports.assertIsNextArbitrary = assertIsNextArbitrary;